export default __webpack_public_path__ + "static/Geely MK-9cc195bae6e867c5e2ec95f472a89244.jpg";